/**
 * Constants for the character creation wizard navigation
 */
import type { WizardStep, DockTab, IdentitySubTab, EquipmentSubTab } from '../types';

/**
 * All wizard steps in order
 */
export const WIZARD_STEPS: WizardStep[] = [
  'basics',
  'race',
  'class',
  'abilities',
  'background',
  'equipment',
  'combat',
  'spells',
  'details',
  'review',
];

/**
 * Information about each wizard step
 */
export const STEP_INFO: Record<WizardStep, { title: string; description: string }> = {
  basics: { title: 'Basics', description: 'Name your character' },
  race: { title: 'Race', description: 'Choose your ancestry' },
  class: { title: 'Class', description: 'Pick your profession' },
  abilities: { title: 'Abilities', description: 'Assign ability scores' },
  background: { title: 'Background', description: 'Your history' },
  equipment: { title: 'Equipment', description: 'Starting gear' },
  combat: { title: 'Combat', description: 'Attacks & weapons' },
  spells: { title: 'Spells', description: 'Spellcasting & magic' },
  details: { title: 'Details', description: 'Personality & backstory' },
  review: { title: 'Review', description: 'Finalize character' },
};

/**
 * 3-tab dock navigation tabs
 */
export const DOCK_TABS: DockTab[] = ['identity', 'equipment', 'spells'];

/**
 * Sub-tabs within the Identity dock tab
 */
export const IDENTITY_SUB_TABS: IdentitySubTab[] = ['basics', 'race', 'class', 'abilities', 'background'];

/**
 * Sub-tabs within the Equipment dock tab
 */
export const EQUIPMENT_SUB_TABS: EquipmentSubTab[] = ['inventory', 'weapons', 'currency'];

/**
 * Information about each dock tab
 */
export const DOCK_TAB_INFO: Record<DockTab, { label: string; description: string; icon: string }> = {
  identity: { label: 'Identity', description: 'Who your character is', icon: 'user' },
  equipment: { label: 'Equipment', description: 'Gear, weapons & currency', icon: 'backpack' },
  spells: { label: 'Spells', description: 'Spellcasting & magic', icon: 'wand' },
};
